// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/build/js/main.script": 0,
	"components/dropdown/dropdown": 0,
	"components/dropdown-menu/dropdown-menu": 0,
	"components/card-egkyklios/card-egkyklios": 0,
	"components/block/block": 0,
	"build/css/main.style": 0,
	"components/views-view/views-view": 0,
	"components/views-view--unformatted/views-view--unformatted": 0,
	"components/views-view--unformatted-news/views-view--unformatted-news": 0,
	"components/views-view--table/views-view--table": 0,
	"components/page/page": 0,
	"components/page-topbar/page-topbar": 0,
	"components/page-sidebar/page-sidebar": 0,
	"components/page-navigation/page-navigation": 0,
	"components/page-footer/page-footer": 0,
	"components/page-credits/page-credits": 0,
	"components/page-content/page-content": 0,
	"components/node/node": 0,
	"components/node-header/node-header": 0,
	"components/node-eikonidio/node-eikonidio": 0,
	"components/node--test--teaser/node--test--teaser": 0,
	"components/node--pliroforisi--teaser-slider-b/node--pliroforisi--teaser-slider-b": 0,
	"components/node--pliroforisi--teaser-slider-a/node--pliroforisi--teaser-slider-a": 0,
	"components/node--pliroforisi--teaser-date/node--pliroforisi--teaser-date": 0,
	"components/navbar/navbar": 0,
	"components/navbar-brand/navbar-brand": 0,
	"components/nav/nav": 0,
	"components/nav-item/nav-item": 0,
	"components/form/form": 0,
	"components/form-element/form-element": 0,
	"components/form-element--radiocheckbox/form-element--radiocheckbox": 0,
	"components/form-element--label/form-element--label": 0,
	"components/field/field": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkapdk"] = self["webpackChunkapdk"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));